import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <g clipPath="url(#clip0_279_53937)">
      <path
        d="M1.3711 14.6705C1.59129 16.7286 3.24657 18.3839 5.30366 18.6132C8.46336 18.9653 11.5363 18.9653 14.696 18.6132C16.7531 18.3839 18.4084 16.7286 18.6286 14.6705C18.7911 13.1512 18.9284 11.5914 18.9284 10.0011C18.9284 8.41091 18.7911 6.85111 18.6286 5.33181C18.4084 3.27374 16.7531 1.61844 14.696 1.38915C11.5363 1.03695 8.46336 1.03695 5.30366 1.38915C3.24657 1.61844 1.59129 3.27374 1.3711 5.33181C1.20855 6.85111 1.07129 8.41091 1.07129 10.0011C1.07129 11.5914 1.20855 13.1512 1.3711 14.6705Z"
        fill="white"
        stroke="#070F21"
      />
      <path d="M12.5254 7.47656L7.47461 12.5273" stroke="#070F21" strokeLinecap="round" />
      <path d="M12.5254 12.5273L7.47461 7.47656" stroke="#070F21" strokeLinecap="round" />
    </g>
    <defs>
      <clipPath id="clip0_279_53937">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const RemoveIcon = memo(ForwardRef);
export default RemoveIcon;
